/** Local calendar date as YYYY-MM-DD — toISOString would slip a day near midnight. */
export const toDateInput = (day: Date): string =>
  `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`
